
import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSocket } from '../../context/SocketContext'
import Loader from '../../compoment/ui/Loader';
import { FullScreenBackground } from '../../compoment/PortraitStage';
import newBg from '../../assets/img/new-bg.png';
import magicTxt from '../../assets/img/magic-txt.png';
import { useRouteFrozen } from '../../routes/routeTransition';

const MagicScreen = () => {

    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate()
    const location = useLocation() as { state?: { wisdom?: string, category?: string, categoryObject?: any, ticketInfo?: any } }
    const { socket } = useSocket();
    const [latestStatus, setLatestStatus] = useState('');
    const routeFrozen = useRouteFrozen();

    // Listen for status updates (submission already emitted on YES, SUBMIT)
    useEffect(() => {
        if (routeFrozen || !socket) return;

        const handler = (update: any) => {
            console.log('Received treeOfWisdomStatusUpdate:', update);
            if (!update || typeof update.status !== 'string') return;

            setLatestStatus(update.status);
            if (update.status === 'free') {
                setLoading(true);
                console.log('Status is free, scheduling navigation in 2.5s');
                setTimeout(() => {
                    setLatestStatus((currentStatus) => {
                        if (currentStatus === 'free') {
                            console.log('Navigating to /');
                            navigate('/');
                        }
                        setLoading(false);
                        return currentStatus;
                    });
                }, 2500);
            }
        };

        const returnToEdit = () => {
            navigate('/main', {
                replace: true,
                state: {
                    ...location.state,
                    showNurture: true,
                },
            });
        };

        socket.on('treeOfWisdomStatusUpdate', handler);
        socket.on('error', returnToEdit);
        socket.on('treeOfWisdomBlocked', returnToEdit);
        return () => {
            socket.off('treeOfWisdomStatusUpdate', handler);
            socket.off('error', returnToEdit);
            socket.off('treeOfWisdomBlocked', returnToEdit);
        };
    }, [socket, navigate, location.state, routeFrozen]);

    useEffect(() => {
        if (routeFrozen) return undefined;
        const timer = setTimeout(() => {
            navigate('/');
        }, 10000);

        return () => clearTimeout(timer);
    }, [navigate, routeFrozen]);


    return (
        <>
            {loading && <Loader />}
            <FullScreenBackground image={newBg} position="center center" />
            <section className="magicSection">
                <div className="magicTxtSection">
                    <img className="magicTxt" src={magicTxt} alt="See the magic come to life on the big screen!" />
                </div>
            </section>
        </>
    );
}


export default MagicScreen;
